module.exports = __webpack_public_path__ + "304add0822a2dcbc1a14185aa7126b62.pdf";